<div style="padding-bottom:1px">
    <div id="_modal-HEADER" class="flex items-center justify-around modal-header">
        <div class="w-11/12 text-left modal-title">Are You Sure?</div>
        <div id="_Buttons" class="flex items-center justify-end">
            <button class="mx-2 px-4 btn" type="button" (click)="dialogRef.close(data)">
                Delete
            </button>
            <button class="px-4 btn" type="button" (click)="dialogRef.close()">
                Cancel
            </button>
        </div>
    </div>

    <div id="_modal-CENTER" class="w-full flex flex-col modal-center">
        <div class="mx-auto w-11/12 font-bold text-center text-red-800 text-2">
            {{title}}
        </div>
        <div class="w-11/12 mx-auto text-1.5 text-center text-red-700">
            {{message}}
        </div>
        <div class="mx-auto w-11/12 font-bold text-center text-2 ism-black">
            Delete the {{data.documentName}}?
        </div>
        @if (data.document) {
        <div class="w-full flex flex-col justify-end ism-black">
            @if (data.documentTemplate) {
            <!-- How to dynamically load template by name with error check?? -->
            }
            @else {
            <!-- css formatting works on the span NOT on the 'pre' -->
            <pre><span>{{data.document | json}}</span></pre>
            }
        </div>
        }
    </div>

    <div id="_modal-FOOTER" class="flex items-center justify-end modal-footer mb-2">
        <button class="mx-2 px-4 btn" type="button" (click)="dialogRef.close(data)">
            Delete
        </button>
        <button class="px-4 btn" type="button" (click)="dialogRef.close()">
            Cancel
        </button>
    </div>
</div>
